<template>
  <div class="chart">
    <div ref="chart"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
export default {
  props: ['series', 'title', 'xAxis', 'yAxis', 'colors'],
  data () {
    return {
      chart: {
        chart: { type: 'column' },
        title: { text: this.title, style: { fontSize: '28px', color: '#6D6D6D' } },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        yAxis: { min: 0, title: { text: this.yAxis }, className: 'Type1ChartYAxis', labels: { overflow: 'justify' } },
        credits: { enabled: false },
        colors: this.colors,
        legend: {
          layout: 'horizontal',
          itemStyle: { fontSize: '24px' }
        }
      },
      chartObj: null
    }
  },
  mounted () {
    this.updatechart()
  },
  watch: {
    series: {
      deep: true,
      handler () {
        this.updatechart()
      }
    },
    colors () {
      if (this.chartObj) {
        this.chartObj.update({
          colors: this.colors
        })
      }
    },
    xAxis () {
      if (this.chartObj) {
        this.chartObj.update({
          xAxis: { categories: this.xAxis }
        })
      }
    },
    yAxis () {
      if (this.chartObj) {
        this.chartObj.update({
          yAxis: { min: 0, title: { text: this.yAxis }, className: 'Type1ChartYAxis', labels: { overflow: 'justify' } }
        })
      }
    },
    title () {
      if (this.chartObj) {
        this.chartObj.update({
          title: { text: this.title }
        })
      }
    }
  },
  methods: {
    updatechart () {
      if (this.chartObj) {
        this.chartObj.update({
          xAxis: { categories: this.xAxis },
          series: this.series
        }, true, true)
      } else {
        this.chartObj = Highcharts.chart(this.$refs.chart, {
          ...this.chart,
          xAxis: { categories: this.xAxis },
          series: this.series
        }, (arg) => {
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.chart {
  width: 831px;
  height: 459px;
  box-shadow: 0px 0px 10px 0px #00000040;
  border-radius: 10px;
  padding: 30px 20px;
}
</style>
